import Axios from 'axios';
import Properties from '../config/properties';

export default () => {
    return Axios.create({
        baseURL: Properties.urlBase
    })
}